import React from 'react';
import { LoadingOverlay } from "../../../../ab-common-legacy/LoadingOverlay";
import { Keys } from "../../Common/Constants";
import Question5Component from "../../Common/Question5";
import { assert } from "../../../../utils/assert";
var HighestEducationQuestionContent = function HighestEducationQuestionContent(_ref) {
  var countriesData = _ref.countriesData,
    degreeErrorMessage = _ref.degreeErrorMessage,
    educationCountryErrorMessage = _ref.educationCountryErrorMessage,
    educationData = _ref.educationData,
    educationLevelErrorMessage = _ref.educationLevelErrorMessage,
    educationStatusErrorMessage = _ref.educationStatusErrorMessage,
    isLoading = _ref.isLoading,
    setDegreeErrorMessage = _ref.setDegreeErrorMessage,
    setEducationCountryErrorMessage = _ref.setEducationCountryErrorMessage,
    setEducationLevelErrorMessage = _ref.setEducationLevelErrorMessage,
    setEducationStatusErrorMessage = _ref.setEducationStatusErrorMessage;
  var clearError = function clearError(keyName) {
    switch (keyName) {
      case Keys.Application.educationCountry:
        setEducationCountryErrorMessage('');
        break;
      case Keys.Application.educationLevel:
        setEducationLevelErrorMessage('');
        break;
      case Keys.Application.educationStatus:
        setEducationStatusErrorMessage('');
        break;
      case Keys.Application.degree:
        setDegreeErrorMessage('');
        break;
      default:
        console.error("".concat(keyName, " is not a valid key name."));
    }
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(LoadingOverlay, {
      "aria-label": "Loading"
    });
  }
  assert(countriesData, 'countriesData should be loaded');
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Question5Component, {
    isMobile: true,
    educationStatusErrorMessage: educationStatusErrorMessage,
    educationCountryErrorMessage: educationCountryErrorMessage,
    educationLevelErrorMessage: educationLevelErrorMessage,
    degreeErrorMessage: degreeErrorMessage,
    clearError: clearError,
    countriesData: countriesData,
    educationData: educationData
  }));
};
export default HighestEducationQuestionContent;